// @ts-nocheck
import { teal } from 'api';
import { getUser } from 'actions/auth';
import { requestStarted, requestSucceeded, requestFailed } from 'store/slices/apiCalls';

export function createOrganisation(organisationData) {
    return async (dispatch) => {
        dispatch(requestStarted({ key: 'organisations.createOrganisation' }));

        let organisation;
        try {
            organisation = await teal.createOrganisation(organisationData);
            dispatch(requestSucceeded({ key: 'organisations.createOrganisation' }));
        } catch(error) {
            dispatch(requestFailed({ key: 'organisations.createOrganisation', error }));
            return error;
        }

        dispatch(getUser());
        return organisation;
    };
}
